import { v4 as uuid } from 'uuid';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	type Action,
	createStore,
	createHook,
	createActionsHook,
} from '@atlassian/react-sweet-state';
import type { QuickSearchAnalyticsState } from './types.tsx';
import { getWordCount, getQueryHash } from './utils.tsx';

const initialState: QuickSearchAnalyticsState = {
	queryVersion: -1,
	query: '',
	searchSessionId: uuid(),
	hasModalWrapperMounted: false,
	screenName: undefined,
	isCachedResult: false,
};

const actions = {
	setQuery:
		(query: string): Action<QuickSearchAnalyticsState> =>
		({ setState, getState }) => {
			setState({ queryVersion: getState().queryVersion + 1, query });
		},
	reset:
		(): Action<QuickSearchAnalyticsState> =>
		({ setState }) => {
			setState({
				...initialState,
				searchSessionId: uuid(),
			});
		},
	setHasModalWrapperMounted:
		(hasModalWrapperMounted: boolean): Action<QuickSearchAnalyticsState> =>
		({ setState }) => {
			setState({ hasModalWrapperMounted });
		},
	setScreenName:
		(screenName: string): Action<QuickSearchAnalyticsState> =>
		({ setState }) => {
			setState({ screenName });
		},
	setIsCachedResult:
		(isCachedResult: boolean): Action<QuickSearchAnalyticsState> =>
		({ setState }) => {
			setState({ isCachedResult });
		},
};

const store = createStore<QuickSearchAnalyticsState, typeof actions>({
	initialState,
	actions,
	name: 'quickSearchAnalytics',
});

export const useQuickSearchAnalytics = createHook(store);
export const useQuickSearchAnalyticsActions = createActionsHook(store);

export const useQuickSearchAnalyticsAttributes = createHook(store, {
	selector: ({
		query,
		queryVersion,
		searchSessionId,
		screenName,
		isCachedResult,
	}: QuickSearchAnalyticsState) => ({
		wordCount: getWordCount(query),
		queryLength: query.length,
		queryHash: getQueryHash(query),
		queryVersion,
		searchSessionId,

		activeProduct: 'jira',
		isMultiProduct: false,

		screenName,
		isCachedResult,
	}),
});
